// Static content shared across the patient portal sub-pages — mirror the
// VitaMed patient-portal mockup so the desktop layout has the same feel
// end-to-end. Replace with real queries when medication/lab/reply tables
// are wired up.
import React from "react";

export const MOCK_MEDICINES = [
  { id: "m1", name: "Lisinopril 20 mg", dose: "1 tablet", reason: "for blood pressure", slot: "morning", taken: true, takenAt: "7:42 AM" },
  { id: "m2", name: "Atorvastatin 40 mg", dose: "1 tablet", reason: "for cholesterol", slot: "morning", taken: true, takenAt: "7:42 AM" },
  { id: "m3", name: "Aspirin 81 mg", dose: "1 tablet", reason: "for heart protection", slot: "morning", taken: true, takenAt: "7:42 AM" },
  { id: "m4", name: "Metoprolol 25 mg", dose: "1 tablet", reason: "for heart rate", slot: "evening", taken: false },
  { id: "m5", name: "Vitamin D 1000 IU", dose: "1 capsule", reason: "with food", slot: "evening", taken: false },
];

export const MOCK_LABS = [
  {
    group: "Heart & cholesterol",
    items: [
      { name: "Total cholesterol", value: "172", unit: "mg/dL", range: "Good range: 125 – 200 mg/dL", status: "NORMAL" },
      { name: 'LDL ("bad" cholesterol)', value: "88", unit: "mg/dL", range: "Good range: under 100 mg/dL", status: "NORMAL" },
    ],
  },
  {
    group: "Blood sugar & kidney",
    items: [
      {
        name: "Hemoglobin A1C",
        value: "6.4",
        unit: "%",
        range: "Borderline blood sugar. Your doctor may want to discuss at your next visit.",
        status: "A LITTLE HIGH",
      },
      {
        name: "Kidney function",
        value: "Creatinine 0.9 · eGFR 84",
        unit: "",
        range: "Kidneys are filtering well.",
        status: "NORMAL",
      },
    ],
  },
];

export const MOCK_CONDITIONS = [
  { icon: "♡", name: "High blood pressure", detail: "Controlled with medicine since 2019" },
  { icon: "⚡", name: "High cholesterol", detail: "Atorvastatin, recheck every year" },
  { icon: "⊙", name: "Borderline diabetes (pre-DM)", detail: "A1C 6.4 · diet & exercise focus" },
];

export const MOCK_REPLIES = [
  { who: "Norinne (RN)", initial: "N", text: '"Yes — coffee is fine. Take with food."', date: "May 30" },
  { who: "Dr. Pallickal", initial: "P", text: '"Your labs look great. Keep walking."', date: "May 24" },
];

export const HELPER_QUICK_PROMPTS = [
  { label: "Show my next appointment", icon: "📅", to: "appointments" },
  { label: "Did I take my morning pills?", icon: "℞", to: "meds" },
  { label: "Send a message to my doctor", icon: "✉", to: "message" },
  { label: "Read my latest lab results", icon: "🧪", to: "labs" },
  { label: "Log my blood pressure", icon: "♡", to: "vitals" },
  { label: "Book a new appointment", icon: "🗓", to: "appointments" },
];

export function ConditionsList({ onClick }) {
  return (
    <>
      {MOCK_CONDITIONS.map((c) => (
        <div
          key={c.name}
          className="pp-cond-row"
          role="button"
          tabIndex={0}
          onClick={onClick}
          onKeyDown={(e) => e.key === "Enter" && onClick && onClick()}
        >
          <div className="pp-cond-icon">{c.icon}</div>
          <div className="pp-cond-body">
            <div className="pp-cond-name">{c.name}</div>
            <div className="pp-cond-detail">{c.detail}</div>
          </div>
          <span className="pp-row-chev">›</span>
        </div>
      ))}
    </>
  );
}